import { useState, useEffect } from 'react';
import { User } from '../types';
import { api } from '../services/api';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      checkUser();
      setInitialized(true);
    }
  }, [initialized]);

  const checkUser = async () => {
    try {
      setLoading(true);
      const { data: { user: supabaseUser }, error } = await api.auth.getUser();
      
      // Si pas d'erreur critique et qu'on a un utilisateur
      if (!error && supabaseUser) {
        setUser({
          id: supabaseUser.id,
          email: supabaseUser.email || undefined
        });
      } else {
        // Pas d'utilisateur connecté, c'est normal
        setUser(null);
      }
    } catch (error: any) {
      // Ne pas logger les erreurs de session manquante
      if (!error.message?.includes('session missing')) {
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const signIn = async (email: string) => {
    const { error } = await api.auth.signInWithOtp(email);
    if (error) throw error;
  };

  const signOut = async () => {
    const { error } = await api.auth.signOut();
    if (error) throw error;
    setUser(null);
  };

  return {
    user,
    loading,
    signIn,
    signOut,
    checkUser
  };
};
